import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Dropdown } from 'semantic-ui-react';
import { COLORS } from '@cuemath/comps';
import { Text } from '@cuemath/web-comps';

const Label = styled(Text)`
  pointer-events: none;
  position: absolute;
  transition: 0.2s ease all;
  -moz-transition: 0.2s ease all;
  -webkit-transition: 0.2s ease all;
  z-index: 24;
  background: ${COLORS.WHITE};
  padding: 0 4px;
  top: ${props => (props.isFloating ? `-10px` : `8px`)};
  left: ${props => (props.isFloating ? `12px` : `12px`)};
  font-size: ${props => (props.isFloating ? `12px` : `1rem`)};
`;

const Root = styled.div`
  position: relative;
`;

const CustomDropdown = styled(Dropdown)`
  .ui.selection.active.dropdown .menu {
    border-color: ${COLORS.GHOST};
  }
  border-radius: 8px !important;
`;

export default function CueSelect({ defaultValue, label, onClick, options }) {
  const [isFloating, setIFloating] = useState(false);
  const [value, setValue] = useState(null);

  function onChange(_e, { value: data }) {
    setValue(data);
    setIFloating(true);
    if (onClick) {
      onClick(data);
    }
  }

  useEffect(() => {
    if (defaultValue) {
      setIFloating(true);
    }
  }, [defaultValue]);

  return (
    <Root>
      <Label variant="body3" color={COLORS.SCORPION} isFloating={isFloating || value}>
        {label}
      </Label>
      <CustomDropdown
        labeled
        onFocus={() => setIFloating(true)}
        onBlur={() => setIFloating(false)}
        onChange={onChange}
        selection
        options={options}
        selectOnBlur={false}
        fluid
        defaultValue={defaultValue}
      />
    </Root>
  );
}
